export const SHIPPING_OPTION_NAME_MAX_LENGTH = 127;
export const ELLIPSIS = '…';
export const NO_ACTIVE_BASKET_SUMMARY_ERROR = 'No active basket summary found';
export const NO_PAYPAL_PAYMENT_NONCE_ERROR = 'PayPal payment nonce is missing';
export const NO_PAYPAL_ORDER_ID_ERROR = 'PayPal order id is missing';
